import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

let userInfoRequestId = 0;

export const createUserInfoSlice = (set, get) => ({
    userInfo: {
        loading: false,
        data: null,
        error: null,
    },
    getUserInfo: async (userId) => {
        const requestId = ++userInfoRequestId;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({
            userInfo: { ...state.userInfo, loading: true, error: null }
        }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/user-info/${userId}`,
                headers: { token }
            });
            if (requestId !== userInfoRequestId) return;
            set(state => ({ userInfo: { loading: false, data: resp.data, error: null } }));
            return resp.data;
        } catch (error) {
            if (requestId !== userInfoRequestId) return;
            set(state => ({
                userInfo: {
                    loading: false,
                    data: null,
                    error: error.message || 'خطا در دریافت اطلاعات کاربر'
                }
            }));
        }
    },
    clearUserInfo: () => {
        set(() => ({ userInfo: { loading: false, data: null, error: null } }));
    }
});
